import React, {useRef, useState} from "react";

import UserDetailHead from "./UserDetailTableHead";
import UserDetail from "./UserDetail";
import ENUMS from "../../utils/ENUMS.js"
import axios from 'axios';
import {useEffect} from "react";
import {toast} from 'react-toastify';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from "react-modal";
import IncedentDeleteModal from "./IncedentDeleteModal";


let get_list = [];
const UserDetailTable = (props) => {
    const {incidents, getIncidents, selectedCourse} = props
    const token = localStorage.getItem(ENUMS.AUTH);
    const [table, SetTable] = useState(incidents);
    const [time, SetTime] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [incidentsPerPage] = useState(15);
    const [modalIsOpen, setModalIsOpen] = useState(false)
    // Get current posts
    const indexOfLastincident = currentPage * incidentsPerPage;
    const indexOfFirstIncident = indexOfLastincident - incidentsPerPage;
    const currentPosts = incidents.slice(indexOfFirstIncident, indexOfLastincident);

    // Change page
    const paginate = pageNumber => {
        setCurrentPage(pageNumber);
        props.incidentRef.current.scrollIntoView();
    }

    return (
        <>

            {/*<UserDetailHead/>*/}
            {/*<UserDetail/>*/}
            <ToastContainer/>
            <Pagination
                postsPerPage={incidentsPerPage}
                totalPosts={incidents.length}
                paginate={paginate}
                currentPage={currentPage}
            />
            <div style={{overflow:"auto"}}>
            <table className="incidents_table"      id={'table-to-xls'}>

                <tr className="incident_table_head">
                    <th className="table__row-0">Number</th>
                    <th className="table__row-0">Date</th>
                    <th className="table__row-0">Time
                        Logged
                    </th>

                    <th className="table__row-0">Area Logged</th>
                    <th className="table__row-0">Incident type</th>
                    <th className="table__row-0">Notes</th>
                    <th className="table__row-0">Logged by</th>
                    <th className="table__row-0">Resolve Issue</th>
                </tr>
                {
                    currentPosts.length === 0 ?

                        // <h2 colspan="2" className="text-jost-sb-22">No Data Available</h2>

                        <tr>
                            <td  className="text-jost-sb-22"  colSpan="8">No Data Available</td>

                        </tr>


                        :

                        currentPosts?.map(user => {
                            console.log(user, "DATA")

                            return (
                                <>
                                    <IncedentDeleteModal
                                        user={user}
                                        {...props}
                                    />

                                </>

                            )
                        })

                }
            </table>
            </div>
            <Pagination
                postsPerPage={incidentsPerPage}
                totalPosts={incidents.length}
                paginate={paginate}
                currentPage={currentPage}
            />

        </>
    );
};

const Pagination = ({postsPerPage, totalPosts, paginate, currentPage}) => {
    const pageNumbers = [];

    for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
        pageNumbers.push(i);
    }

    return (
        <>
            <ul className='pagination'>
                {pageNumbers.map((number, index) => (
                    <li onClick={() => paginate(number)} key={number} className={index+1===currentPage ? 'page-item active' : 'page-item'}>
                        <a className='page-link'>
                            {number}
                        </a>
                    </li>
                ))}
            </ul>
        </>
    );
};

export default UserDetailTable;
